export default __webpack_public_path__ + "static/media/iconfinder_sass_1297046.67308595.svg";